<template>
  <div class="process-slider">
    <div class="process-slider-button process-slider-previous" @click="previousSlide" v-if="current != 1"><img class="previous" src="../../assets/chevron.svg" /></div>
    <div class="process-slider-button process-slider-next" @click="nextSlide" v-if="current != total"><img class="next" src="../../assets/chevron.svg" /></div>
    <div class="process-slider-container" :style="containerStyle()">
      <div class="process-slider-card" v-for="(card, key) in cards" :key="key" :style="cardStyle(key)" :class="cardClass(key)">
        <div class="process-icon" :style="'background-image: url(' + card.icon + ')'"></div>
        <h4 unselectable="on" class="unselectable">{{card.title}}</h4>
        <p unselectable="on" class="unselectable">{{card.body}}</p>
      </div>
    </div>
    <div class="process-slider-dots">
      <div class="process-slider-dot" v-for="(card, key) in cards" :key="key" :style="progressStyle(key)"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .process-slider {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 100%;
    overflow: hidden;
  }

  img.next {
    width: 20px;
    height: 20px;
  }

  img.previous {
    transform: rotate(180deg);
    width: 20px;
    height: 20px;
  }

  h4 {
    font-family: 'OpenSans-Bold', sans-serif;
    font-weight: 700;
  }

  .process-slider-container {
    height: 420px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    transition: transform 0.25s ease-in-out;

    @media(min-width: 481px) {
      height: 420px;
    }

    @media(max-width: 480px) {
      height: 500px;
    }
  }

  .process-slider-card {
    border-radius: 10px;
    padding: 1em;
    margin: 1em;
    background: white;
    color: #363867;
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
    transform-origin: center center;
    transition: transform 0.25s, background 0.4s, width 1s, height 0.2s, z-index 0.1s;
    display: flex;
    flex-direction: column;
    width: 290px;
    transition-delay: 0.2s;

    @media(min-width: 481px) {
      height: 200px;
    }

    @media(max-width: 480px) {
      height: 380px;
    }

    p {
      color: #363867;
      margin: 0 0.5rem;
      padding: 0;
      font-size: 0.8rem;
      transition: opacity 0.15s;
      opacity: 0;
      user-select: none;
    }
  }

  .previous-process-slider-card {
    transition-delay: 0s;
    transition: transform 0.25s, background 0.4s, width 1s, height 0.5s, z-index 0.6s;

    p {
      opacity: 0;
    }
  }

  .next-process-slider-card {
    transition-delay: 0s;
    transition: transform 0.25s, background 0.4s, width 1s, height 0.1s, z-index 0.8s;

    p {
      opacity: 0;
    }
  }

  .active-process-slider-card {
    transition-delay: 0.15s;
    transition: transform 0.25s, background 0.4s, width 1s, height 0.1s, z-index 0.25s;

    @media(min-width: 481px) {
      height: 320px;
      width: 290px;
    }

    @media(max-width: 480px) {
      height: 360px;
      max-width: 200px;
    }

    p {
      opacity: 1;
    }
  }

  .process-slider-button {
    position: absolute;
    z-index: 1;
    margin-top: -22px;
    background: #272460;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 1.3em;
    font-family: sans;

    @media(min-width: 481px) {
      height: 420px;
    }

    @media(max-width: 480px) {
      height: 500px;
    }
  }

  .process-icon {
    width: 80px;
    height: 80px;
    min-width: 80px;
    min-height: 80px;
    align-self: center;
    margin: 1rem;
  }

  .process-slider-previous {
    border-radius: 10px 0 0 10px;

    @media(min-width: 481px) {
      left: calc(50% - 228px);
    }

    @media(max-width: 480px) {
      left: 0;
    }
  }

  .process-slider-next {
    border-radius: 0 10px 10px 0;

    @media(min-width: 481px) {
      right: calc(50% - 228px);
    }

    @media(max-width: 480px) {
      right: 0;
    }
  }

  .process-slider-dots {
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 12px;
    margin: 2rem 0 0 0;
  }

  .process-slider-dot {
    background: white;
    width: 8px;
    height: 8px;
    border-radius: 100%;
    margin: 0 0.5em;
    opacity: 0.6;
    transition: transform 0.3s ease-in-out;
  }
</style>

<script>
export default {
  data () {
    return {
      total: 0,
      current: 0,
      middle: 0
    }
  },
  props: {
    cards: {
      required: true
    }
  },
  created () {
    this.total = this.cards.length
    this.current = Math.ceil(this.cards.length / 2)
    this.middle = this.current
  },
  methods: {
    previousSlide () {
      this.current--
    },
    nextSlide () {
      this.current++
    },
    cardClass (key) {
      if ((key + 1) === this.current) {
        return 'active-process-slider-card'
      }

      if ((key + 1) === (this.current - 1)) {
        return 'previous-process-slider-card'
      }

      if ((key + 1) === (this.current + 1)) {
        return 'next-process-slider-card'
      }
    },
    containerStyle () {
      const gap = (this.middle - (this.current))
      const amount = 322 * gap

      return `transform: translate3d(${amount}px, 0, 0);`
    },
    progressStyle (key) {
      if ((key + 1) === this.current) {
        return 'transform: scale(1.3); opacity: 1;'
      }

      if ((key + 1) === (this.current - 1)) {
        return 'transform: scale(1.1);'
      }

      if ((key + 1) === (this.current + 1)) {
        return 'transform: scale(1.1);'
      }
    },
    cardStyle (key) {
      const gap = (this.current - (key + 1)) * -1
      const zindex = (this.total - (Math.abs(gap))) * 2

      if ((key + 1) === this.current) {
        return `transform: scale(1.3); z-index: ${zindex};`
      }

      if ((key + 1) === (this.current - 1)) {
        return `transform: scale(1.1) translate3d(-5px, 0, 0);  z-index: ${zindex}; background: rgb(252,252,252);`
      }

      if ((key + 1) === (this.current + 1)) {
        return `transform: scale(1.1) translate3d(-5px, 0, 0); z-index: ${zindex}; background: rgb(252,252,252);`
      }

      let pull = 0

      // We need to 'pull' the cards to the right closer to make them overlap
      if (key > this.current - 1) {
        pull = ((this.current - (key + 1)) * 10) * (this.current - (key + 2)) * -1
      }

      // Likewise on the left
      if (key < this.current + 1) {
        pull = ((this.current - (key + 1)) * 10) * (this.current - (key + 2))
      }

      return `transform: translate3d(${pull}px, 0, 0); z-index: ${zindex}; background: rgb(242,242,242);`
    }
  }
}
</script>
